import { Typography } from "@circle-react-shared/uikit/Typography";

interface TitleProps {
  title: string;
}

export const Title = ({ title }: TitleProps) => (
  <div className="py-2" data-testid="benefits-title">
    <Typography.TitleSm weight="semibold">{title}</Typography.TitleSm>
  </div>
);
